import { theme } from '@prophecy/theme';
import { Container, Stack } from '@prophecy/ui-v3';
import styled from 'styled-components';

/** Page frame shared by the project listing and the Types Library, so the two stay visually identical. */

export const Root = styled(Stack)`
  overflow-y: auto;
  height: 100%;
`;

export const StyledContainer = styled(Container)`
  padding-top: ${theme.spaces.x80};
  overflow: initial;
  margin: 0 auto;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spaces.x12};
`;

export const StyledTabBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spaces.x12};
`;

export const StyledTabGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spaces.x4};
  background: ${theme.colors.gray100};
  border-radius: ${theme.radius.x8};
  padding: 3px;
`;

export const StyledTab = styled.button<{ $active: boolean }>`
  all: unset;
  cursor: pointer;
  padding: ${theme.spaces.x4} ${theme.spaces.x12};
  border-radius: ${theme.radius.x6};
  font-size: 14px;
  font-weight: ${(p) => (p.$active ? theme.fontWeight.semiBold : theme.fontWeight.normal)};
  color: ${(p) => (p.$active ? theme.colors.gray900 : theme.colors.gray600)};
  background: ${(p) => (p.$active ? theme.colors.white : 'transparent')};
  box-shadow: ${(p) => (p.$active ? theme.shadows.sm : 'none')};
  transition:
    background 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    color: ${theme.colors.gray900};
  }
`;

export const StyledSearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spaces.x8};
`;

export const StyledSearchInput = styled.div`
  width: 220px;
`;

export const StyledProjectGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spaces.x16};
  padding: ${theme.spaces.x16} 0;
`;

export const PROJECT_LIST_STATE_HEIGHT = '200px';
